






import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'c-surveys-chart'
})
export default class SurveyChart extends Vue {
  @Prop(String) title!: string
  @Prop(Array) data!: any[]

  chartOptions = {
    chart: {
      type: 'bar',
      height: '300px',
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginLeft: '30',
      marginRight: '40',
      marginTop: '25'
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    colors: [
      '#7cb5ec',
      '#434348',
      '#90ed7d',
      '#f7a35c',
      '#8085e9',
      '#f15c80',
      '#e4d354',
      '#2b908f',
      '#f45b5b',
      '#91e8e1'
    ],
    xAxis: {
      categories: [''],
      gridLineColor: '#9A99A299',
      lineColor: '#9A99A299',
      tickInterval: 1
    },
    yAxis: {
      tickInterval: 1,
      gridLineColor: '#9A99A299',
      lineColor: '#9A99A299',
      min: 0,
      title: {
        text: this.$t('statistic.surveysChart.totalAnswers')
      }
    },

    legend: {
      reversed: true,
      maxHeight: 100,
      x: 2
    },

    plotOptions: {
      series: {
        stacking: 'normal'
      },
      bar: {
        borderColor: '#9A99A2',
        dataLabels: {
          enabled: true
        }
      },
      line: {
        color: '#00000'
      }
    },
    series: this.data
  }

  @Watch('data')
  isDataChanged (newVal: any, oldVal: any) {
    if (JSON.stringify(newVal) === JSON.stringify(oldVal))
      return

    const elem = (this.$refs.charts as any)
    elem.chart.update(
      {
        series: newVal,
      },
      true,
      true,
      true
    )
  }
}
